export class LoadClientParameterizationModel{

    total:number;
    constructor (){}
}